module.exports = "/static/assets/c21659046f2d2b31044d7cecdac154cc.svg";